
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Signup from './components/Auth/Signup/Signup';
import Login from './components/Auth/Login/Login';
import FormCandidat from './components/Auth/Signup/formCandidat';
import FormEntreprise from './components/Auth/Signup/formEntreprise';
import FormRecruteur from './components/Auth/Signup/formRecruteur';
import DashboardEntreprise from './components/Entreprise/Dashboard/Dashboard';
import DashboardRecruteur from './components/Recruteur/Dashboard/Dashboard';
import Entreprises from './components/Admin/Entreprises/Entreprises';
import Recruteur from './components/Recruteur/Recruteur';
import Recruteurs from './components/Admin/Recruteurs/Recruteurs';
import Users from './components/Admin/Users/Users';
import Dashboard from './components/Admin/Dashboard/Dashboard';
import Candidatures from './components/Admin/Candidatures/Candidatures';
import Missions from './components/Admin/Missions/Missions';
import Home from './components/Home/Home'; 
import ProtectedRoute from './components/ProtectedRoute ';
import Addmission from './components/Entreprise/Addmission/Addmission';
import Cvthèque from './components/Admin/Candidats/Cvthèque';
import MissionsEntreprise from './components/Entreprise/Missions/MissionsEntreprise';
import ProfilEntreprise from './components/Entreprise/Profil/ProfilEntreprise';
import ProfilRecruteur from './components/Recruteur/Profil/ProfilRecruteur';
import MesTalents from './components/Recruteur/candidat/mesTalents';
import Detailsmission from './components/Entreprise/Detailsmission/Detailsmission';
import AddTalent from './components/Recruteur/candidat/AddTalent/AddTalent';
import AllMissions from './components/Recruteur/Mission/AllMissions';
import DetailMission from './components/Recruteur/DetailMission/DetailMission';
import Candidature from './components/Recruteur/candidatures/candidature';
import SendCandidats from './components/Recruteur/SendCandidats/SendCandidats';
import DetailTalent from './components/Recruteur/candidat/detailTalent/detailTalent';
import MyProfils from './components/Recruteur/MyProfils/MyProfils';
import CandidaturesEntreprise from './components/Entreprise/CandidaturesEntreprise/CandidaturesEntreprise';
import DetailsCandidature from './components/Entreprise/CandidaturesEntreprise/DetailsCandidature';
import DetailsCandid from './components/Recruteur/candidatures/DetailsCandid';
import ForgotPassword from './components/Auth/Login/ForgotPassword';
import ResetPassword from './components/Auth/Login/ResetPassword';
import PageMaintenance from './components/commun/PageMaintenance';
import PageContact from './components/Home/PageContact';
import AdministrationPage from './components/Admin/Administration/Administration';
import EmailTemplates from './components/Admin/Administration/Templates/EmailTemplates';
import AddEmailTemplate from './components/Admin/Administration/Templates/AddEmailTemplate';
import EditEmailTemplate from './components/Admin/Administration/Templates/EditEmailTemplate';
import ContactMessages from './components/Admin/Administration/ContactMessages/ContactMessages';
import LogsView from './components/Admin/Administration/Logs/LogsView';
import RolesPage from './components/Admin/Administration/Roles/RolesPage';
import RecruteurDetail from './components/Admin/Recruteurs/RecruteurDetail';
import SettingsHome from './components/Admin/Administration/Settings/SettingsHome'
import NiveauSettings from './components/Admin/Administration/Settings/Niveaux/NiveauSettings'
import StatistiquesPage from './components/Recruteur/Statistiques/StatistiquesRec';
import StatistiquesRecruteursPage from './components/Admin/Administration/Statistiques/StatistiquesRecruteurs';
import EntrepriseDetails from './components/Admin/Entreprises/EntrepriseDetails';
import DashboardCandidat from './components/Candidat/Dashbaord';
import MesCvs from './components/Candidat/MesCvs';
import Services from './components/Home/Services';
import About from './components/Home/About';
import TravailMission from './components/Recruteur/Travail/TravailMission';
import Facture from './components/Entreprise/Factures/Factures';
import CGU from './components/legal/Cgu';
import PolitiqueCookies from './components/legal/PolitiqueCookies';
import PolitiqueConfidentialite from './components/legal/PolitiqueConfidentialite';
import MentionsLegales from './components/legal/MentionsLegales';
import FaqCooptaleo from './components/legal/FaqCooptaleo';

import FicheConsultantTransformationDigitale from './components/Métiers/CTD';
import FicheIngenieurIA from './components/Métiers/FicheIngenieurIA';
import FicheChefProjetAgile from './components/Métiers/ChefProjetAgile';
import FicheConsultantCybersecurite from './components/Métiers/CCybersecurite';
import FicheDeveloppeurBackEnd from './components/Métiers/FicheDeveloppeurBackEnd';
import FicheDataAnalyst from './components/Métiers/FicheDataAnalyst';
import FicheDataEngineer from './components/Métiers/FicheDataEngineer';
import FicheDataScientist from './components/Métiers/FicheDataScientist';
import FicheDeveloppeurFullStack from './components/Métiers/DFullStack';
import FicheDeveloppeurMobile from './components/Métiers/DMobile';
import FicheExpertMachineLearning from './components/Métiers/ExpertMachineLearning';
import FicheIngenieurBigData from './components/Métiers/IngenieurBigData';
import FicheDeveloppeurFrontEnd from './components/Métiers/DFrontEnd';
import FicheIngenieurDevOps from './components/Métiers/DevOps';
import FicheScrumMaster from './components/Métiers/FicheScrumMaster';
import FicheTesteurQA from './components/Métiers/FicheTesteurQA';
import FicheUIUXDesigner from './components/Métiers/FicheUIUXDesigner';
import MetiersIndex from './components/Métiers/MetiersIndex';
import FicheIngenieurCloud from './components/Métiers/Cloud';
import TalentCard from './components/commun/TalentCard';
import AllSuggestedTalents from './components/commun/AllSuggestedTalents'; 

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />  
         
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup/entreprise" element={<FormEntreprise />} />
          <Route path="/signup/recruteur" element={<FormRecruteur />} />
          <Route path="/signup/candidat" element={<FormCandidat />} />
          <Route path="/reset-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/contact" element={<PageContact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/cookie-policy" element={<PolitiqueCookies />} />
          <Route path="/confidentiality" element={<PolitiqueConfidentialite />} />
          <Route path="/legale" element={<MentionsLegales />} />
          <Route path="/faq" element={<FaqCooptaleo  />} />
          <Route path="/fiches/consultant-transformation-digitale" element={<FicheConsultantTransformationDigitale />} />
          <Route path="/fiches/ingenieur-ia" element={<FicheIngenieurIA />} />
          <Route path="/fiches/chef-projet-agile" element={<FicheChefProjetAgile />} />
          <Route path="/fiches/consultant-cybersecurite" element={<FicheConsultantCybersecurite />} />
          <Route path="/fiches/developpeur-backend" element={<FicheDeveloppeurBackEnd />} />
          <Route path="/fiches/data-analyst" element={<FicheDataAnalyst />} />
          <Route path="/fiches/data-engineer" element={<FicheDataEngineer />} />
          <Route path="/fiches/data-scientist" element={<FicheDataScientist />} />
          <Route path="/fiches/developpeur-fullstack" element={<FicheDeveloppeurFullStack />} />
          <Route path="/fiches/developpeur-mobile" element={<FicheDeveloppeurMobile />} />
          <Route path="/fiches/expert-machine-learning" element={<FicheExpertMachineLearning />} />
          <Route path="/fiches/ingenieur-big-data" element={<FicheIngenieurBigData />} />
          <Route path="/fiches/developpeur-frontend" element={<FicheDeveloppeurFrontEnd />} />
          <Route path="/fiches/ingenieur-devops" element={<FicheIngenieurDevOps />} />
          <Route path="/fiches/scrum-master" element={<FicheScrumMaster />} />
          <Route path="/fiches/testeur-qa" element={<FicheTesteurQA />} />
          <Route path="/fiches/ui-ux-designer" element={<FicheUIUXDesigner />} />
          <Route path="/fiches/cloud" element={<FicheIngenieurCloud />} />
          <Route path="/fiches" element={<MetiersIndex />} />
          <Route path="/missions/:id" element={<TalentCard />} />
          <Route path="/missions/:id/talents" element={<AllSuggestedTalents />} />




          <Route element={<ProtectedRoute/>}>

          <Route path="/admin/parametres" element={<SettingsHome />} />
          <Route path="/admin/parametres/niveaux" element={<NiveauSettings />} />


          <Route path="/admin/entreprises" element={<Entreprises />} />
          <Route path="/admin/recruteurs" element={<Recruteurs />} />
          <Route path="/admin/utilisateurs" element={<Users />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/candidatures" element={<Candidatures />} />
          <Route path="/admin/missions" element={<Missions />} />
          <Route path="/admin/cvtheque" element={< Cvthèque/>} /> 
          <Route path="/admin/administration" element={<AdministrationPage />} />
          <Route path="/admin/email-templates" element={<EmailTemplates />} />
          <Route path="/admin/email-templates/add" element={<AddEmailTemplate />} />
          <Route path="/admin/email-templates/:id" element={<EditEmailTemplate />} />
          <Route path="/admin/contact-messages" element={<ContactMessages />} />
          <Route path="/admin/logs" element={<LogsView />} />
          <Route path="/admin/add-talent" element={< AddTalent/>} />
          <Route path="/admin/roles" element={<RolesPage />} />
          <Route path="/admin/recruteur/:id" element={<RecruteurDetail />} />
           <Route path="/commercial/add-talent" element={< AddTalent/>} />
          <Route path="/commercial/cvtheque" element={< Cvthèque/>} />   
          <Route path="/agent/cvtheque" element={< Cvthèque/>} />           
          <Route path="/agent/add-talent" element={< AddTalent/>} />
          <Route path="/agent/dashboard" element={<Dashboard />} />
          <Route path="/commercial/dashboard" element={<Dashboard />} />
          <Route path="/admin/statistiques-recruteurs"element={<StatistiquesRecruteursPage />}/>
          <Route path="/admin/entreprises/:id" element={<EntrepriseDetails />} />



          <Route path="/Recruteur" element={<DashboardRecruteur />} />
          <Route path="/Recruteur/:id" element={<Recruteur />} />
          <Route path="/Recruteur/talents" element={< MesTalents/>} />
          <Route path="/Recruteur/add-talent" element={< AddTalent/>} />
          <Route path="/Recruteur/Allmissions" element={< AllMissions/>} />
          <Route path="/Recruteur/favoris" element={< AllMissions/>} />
          <Route path="/Recruteur/Mesmissions" element={< AllMissions/>} />
          <Route path="/Recruteur/Details/:id" element={<DetailMission />} />
          <Route path="/Recruteur/candidature" element={<Candidature />} />
          <Route path="/Recruteur/sendcandidature" element={<SendCandidats />} />
          <Route path="/Recruteur/Dashboard" element={<DashboardRecruteur />} />
          <Route path="/Recruteur/talent-detail/:talentId" element={<DetailTalent />} />
          <Route path="/Recruteur/profils" element={<MyProfils />} />
          <Route path="/Recruteur/DetailsCandidature/:id" element={<DetailsCandid />} />
          <Route path="/Recruteur/statistiques" element={<StatistiquesPage />} />
          <Route path="/Recruteur/travailler-mission/:id" element={<TravailMission />} />


          <Route path="/Entreprise" element={<DashboardEntreprise />} />
          <Route path="/Entreprise/Addmission" element={<Addmission />} />
          <Route path="/Entreprise/Missions" element={<MissionsEntreprise />} />
          <Route path="/Entreprise/Profile" element={<ProfilEntreprise />} />
          <Route path="/Recruteur/Profile" element={<ProfilRecruteur />} />
          <Route path="/Entreprise/Details/:id" element={<Detailsmission />} />
          <Route path="/Entreprise/Candidatures" element={<CandidaturesEntreprise />} />
          <Route path="/Entreprise/Dashboard" element={<DashboardEntreprise />} />
          <Route path="/Entreprise/DetailsCandidature/:id" element={<DetailsCandidature />} />
          <Route path="/Entreprise/factures" element={<Facture />} />


          <Route path="/Candidat/Dashboard" element={<DashboardCandidat />} />
          <Route path="/Candidat" element={<DashboardCandidat />} />
          <Route path="/Candidat/MesCvs" element={<MesCvs />} />

          </Route>
          <Route path="*" element={<PageMaintenance />} />
          <Route path="/access-denied" element={<PageMaintenance isForbidden={true} />} />

          </Routes>
      </div>

    </Router>
  
  );
}

export default App;

